import { onError } from '@apollo/client/link/error';
import { handleGraphQLError } from '../errorHandling';

/**
 * @name errorLinkFn
 * @public
 * @description Handles GraphQL errors and network errors.
 * Processes each GraphQL error through the error handler and logs details to console.
 * Also logs any network errors that occur.
 * @param {Object} options - The error information object
 * @param {Array<Object>} [options.graphQLErrors] - List of GraphQL errors
 * @param {Object} [options.networkError] - Network error information
 * @returns {void}
 */
export const errorLinkFn = ({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((err) => {
      const { message, locations, path } = err;

      handleGraphQLError(err);

      // eslint-disable-next-line no-console
      console.log(
        '[GraphQL error]: Message: ',
        message,
        'Location: ',
        locations,
        'Path',
        path,
      );
    });
  }

  // eslint-disable-next-line no-console
  if (networkError) console.log('[Network error]: ', networkError);
};

/**
 * @name errorLink
 * @public
 * @description Apollo Link middleware that intercepts and processes GraphQL errors.
 * Uses the onError function from Apollo to handle both GraphQL and network errors.
 * @returns {Object} Apollo Link middleware for error handling
 */
const errorLink = onError(errorLinkFn);

export default errorLink;
